<template>
  <div id="app" class="default-layout" :class="className">
    <AppBar></AppBar>
    <main>
      <div v-if="$route.path != '/'">        
        <div style="background: white;border-bottom: 1px solid rgba(0,0,0,0.25);position: fixed;width: 100%;">
          <div class="row">
            <div class="sm-12">
              <identificacao-cliente></identificacao-cliente>
              <br />
            </div>
          </div>
        </div>
        <div style="height: 90px"></div>
      </div>
      <!--<img src="/images/easy/logo.png" class="logo" >-->
      <router-view></router-view>
      <!--<Popups ></Popups>-->
      <div class="bottom-bar">
        <img :src="logo" class="logo no-print" />
        <img :src="logo_impressao" class="logo print" />
      </div>
    </main>
    <!--<TabBar></TabBar>-->
    <Drawer></Drawer>
    <AssessorVirtual v-if="
      empresa.assessor_virtual && assessor_virutal_contato
    "></AssessorVirtual>
    <FlowXo :user_id="user_id" :extra_info="additionalInfo" v-if="mostraFlowxo"></FlowXo>
  </div>
</template>
<script>
import AppBar from "../components/AppBar.vue";
import TabBar from "../components/TabBar.vue";
import Drawer from "../components/Drawer.vue";
import AssessorVirtual from "../components/AssessorVirtual.vue";
import FlowXo from "../components/FlowXo.vue";
import { empresa } from "../store/empresas";
import IdentificacaoCliente from "~/components/IdentificacaoCliente.vue";
import router from "~/router/router";

export default {
  components: {
    AppBar,
    TabBar,
    Drawer,
    AssessorVirtual,
    FlowXo,
    IdentificacaoCliente
  },
  data() {
    return {
      mostrar_flowxo: true,
      user_id: this.$store.state.cliente.cpf,
      additionalInfo: {
        codigo: this.$store.state.cliente.codigo,
      },
    };
  },
  computed: {
    logo() {
      return this.empresa.imgs.logo;
    },
    logo_impressao() {
      return this.empresa.imgs.logo_impressao;
    },
    cliente() {
      return this.$store.state.cliente;
    },
    empresas() {
      return this.$store.state.empresas;
    },
    empresa() {
      return this.$store.state.empresa;
    },
    className() {
      return this.empresa.className;
    },
    assessor_virutal_contato() {
      return (
        this.$store.getters.controleAcesso?.agenciaVirtual?.contato || false
      );
    },
    mostraFlowxo() {
      //return (this.empresa.assessor_virtual && this.assessor_virtual_contato && this.mostrar_flowxo) ? FlowXo : null;
      //o codigo acima nao funciona por motivos de nao sei
      if (
        this.empresa.assessor_virtual &&
        this.assessor_virutal_contato &&
        this.mostrar_flowxo
      ) {
        this.ocultaFlowXo();
        return FlowXo;
      } else {
        return null;
      }
    },
  },
  watch: {
    mostraFlowxo() {
      this.ocultaFlowXo();
      if (!this.mostraFlowxo) {
        this.destroyFlowXo();
      }
      this.ocultaFlowXo();
    },
    easy: {
      immediate: true,
      handler() {
        let classes = this.empresas.map(({ className }) => className);
        document.body.classList.remove(...classes);
        document.body.classList.add(this.className);
      },
    },
  },
  mounted() {
    this.ocultaFlowXo();
    if (empresa.hotjar) {
      const hotjarScript = document.createElement("script");
      hotjarScript.innerHTML = empresa.hotjar;
      const headerElement = document.head;
      headerElement.appendChild(hotjarScript);
    }
  },
  methods: {
    destroyFlowXo() {
      let iframe = document.querySelector("#fxo-widget-iframe");
      if (iframe) {
        iframe.remove();
      }
      let container = document.querySelector("#fxo-messenger-iframe-container");
      if (container) {
        container.remove();
      }
    },
    ocultaFlowXo() {
      setTimeout(() => {
        const floxo = document.querySelector("#fxo-widget-iframe");
        if (floxo) {
          floxo.style.display = "none";
        }
      }, 500);
    },
  },
};
</script>
<style lang="less">
@import "/css/buttons.less";

#app {
  height: 100%;
  width: 100%;
  display: grid;
  background-color: #eeeeee;
  //padding-bottom: 72px;
  grid-template-columns: 1fr;
  grid-template-rows: 70px 1fr;
  grid-template-areas:
    "header"
    "main";

  @media screen and (min-width: 60em) {
    grid-template-rows: 90px 1fr;
  }

  @media screen and (max-width: 60em) {
    //padding-bottom: 46px;
  }
}

main {
  overflow-y: auto;
  grid-area: main;
}

.bottom-bar {
  background-color: var(--primary);
  padding: 5px 0;
  display: flex;
  justify-content: center;
  //position: absolute;
  //left: 0;
  //bottom: 0;
  width: 100%;

  img {
    max-width: 104px;

    @media (max-width: 60em) {
      max-width: 60px;
    }
  }

  @media print {
    background-color: white;
  }
}

@media screen and (min-width: 60em) {
  #app.default-layout {
    // grid-template-columns: 320px 1fr;

    // grid-template-areas:
    //   "header main"
    //   "drawer main";
  }
}
</style>
